import React, { memo } from 'react';
import { radiansToDegrees, round, SHAPE_COMPONENT_MAP } from '@wix/seating-common-components';
export var Shapes = memo(function (_a) {
    var shapes = _a.shapes;
    return (React.createElement(React.Fragment, null, shapes.map(function (definition) {
        var ShapeComponent = SHAPE_COMPONENT_MAP[definition.type];
        var width = definition.width, height = definition.height, angle = definition.angle;
        var rotatedDegrees = radiansToDegrees(angle);
        var midX = round(width / 2);
        var midY = round(height / 2);
        return (React.createElement("svg", { key: definition.id, x: definition.x, y: definition.y },
            React.createElement("g", { transform: "rotate(".concat(rotatedDegrees, " ").concat(midX, " ").concat(midY, ")") },
                React.createElement(ShapeComponent, { definition: definition }))));
    })));
});
//# sourceMappingURL=shapes.js.map